import { useState } from "react";
import { saveCredentialK8Pay } from "./api-credential-k8-pay";
import { toast } from "react-toastify";
import CredentialK8PayForm from "./CredentialK8PayForm";
import { Grid, Typography } from "@mui/material";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import GridPaper from "../../util/GridPaper";

const CredentialK8PayContainer = () => {
  const [credentialK8Pay, setCredentialK8Pay] = useState({
    clientId: "********",
    clientSecret: "********",
    chaveAES: "********",
  });

  const handleSave = () => {
    if (credentialK8Pay.clientId === null || credentialK8Pay.clientId === "") {
      errorMessage("Campo ClientId não pode ser vazio.");
    } else if (
      credentialK8Pay.clientSecret === null ||
      credentialK8Pay.clientSecret === ""
    ) {
      errorMessage("Campo ClientSecret não pode ser vazio.");
    } else if (
      credentialK8Pay.chaveAES === null ||
      credentialK8Pay.chaveAES === ""
    ) {
      errorMessage("Campo ChaveAES não pode ser vazio.");
    }

    saveCredentialK8Pay(credentialK8Pay).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setCredentialK8Pay({
            clientId: "********",
            clientSecret: "********",
            chaveAES: "********",
          });
          toast.success("Operação Realizada com Sucesso.");
        }
      }
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography variant='h5'>Credenciais K8 Pay</Typography>
      </Grid>
      <GridPaper size={12}>
        <CredentialK8PayForm
          credentialK8Pay={credentialK8Pay}
          setCredentialK8Pay={setCredentialK8Pay}
          handleSave={handleSave}
        />
      </GridPaper>
    </Grid >
  );
};

export default CredentialK8PayContainer;
